/**
 * Menu mobile: botão hambúrguer + submenus em acordeão.
 *
 * Abaixo de 768px, cada <li> com filhos ganha um botão extra (envolvendo o
 * <a> original numa <div class="site-header__row">) que abre/fecha o próprio
 * submenu — sem isso o submenu só abre no :hover, que não existe em touch.
 * Acima de 768px o DOM volta ao original, pra não interferir no menu em
 * cascata lateral do desktop.
 */

const CHEVRON_SVG = '<svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export const initMobileNav = () => {
  const header = document.getElementById('site-header');
  const toggle = header?.querySelector('.site-header__toggle');
  const nav = document.getElementById('site-header-nav');
  if (!header || !toggle || !nav) return;

  const closeNav = () => {
    header.classList.remove('is-nav-open');
    toggle.setAttribute('aria-expanded', 'false');
  };

  toggle.addEventListener('click', () => {
    const isOpen = header.classList.toggle('is-nav-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  const mq = window.matchMedia('(max-width: 768px)');
  let wrapped = false;

  const wrapForMobile = () => {
    if (wrapped) return;
    nav.querySelectorAll('li.menu-item-has-children').forEach((li) => {
      const link = li.querySelector(':scope > a');
      if (!link) return;

      const row = document.createElement('div');
      row.className = 'site-header__row';
      li.insertBefore(row, link);
      row.appendChild(link);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'site-header__submenu-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Abrir submenu');
      btn.innerHTML = CHEVRON_SVG;
      row.appendChild(btn);

      btn.addEventListener('click', () => {
        const isOpen = li.classList.toggle('is-submenu-open');
        btn.setAttribute('aria-expanded', String(isOpen));
      });
    });
    wrapped = true;
  };

  const unwrapForDesktop = () => {
    if (!wrapped) return;
    nav.querySelectorAll('.site-header__row').forEach((row) => {
      const li = row.parentElement;
      const link = row.querySelector('a');
      li.insertBefore(link, row);
      row.remove();
      li.classList.remove('is-submenu-open');
    });
    closeNav();
    wrapped = false;
  };

  const sync = () => (mq.matches ? wrapForMobile() : unwrapForDesktop());
  sync();
  mq.addEventListener('change', sync);
};
